import React  from 'react'
import {
  SubFLex,
  MainHeading,
  SecondaryHeading,
  SecondGreyText,
} from 'modules/Resume/Style/style'
import { COLORS } from 'theme'
import moment from 'moment'
const CurrentlyPursuing = ({studentDetails,instituteName}) => {
  const currentDate = moment()
  return (
    <>
    {
    moment(parseInt(studentDetails?.currentCourse?.endedOn)).format('YYYY-MM-DD') > currentDate.format('YYYY-MM-DD') === true ?
      <MainHeading>Currently Pursuing</MainHeading>
      :
      ''
  }
      <SubFLex column gap="10px">
        <SecondaryHeading fontWeight="600">
          {instituteName?.campusName}
        </SecondaryHeading>

        <SecondGreyText>
          {studentDetails?.currentCourse?.degree} in {studentDetails?.currentCourse?.department} {studentDetails?.currentCourse?.specialisation ? `(${studentDetails?.currentCourse?.specialisation})` : null}
          {studentDetails?.currentCourse?.university ? ` from ${typeof studentDetails?.currentCourse?.university === 'object' ? studentDetails?.currentCourse?.university?.university : studentDetails?.currentCourse?.university}` : null}
         
        </SecondGreyText>
        <SubFLex gap="50px">
          <SecondGreyText color={COLORS.GREY_T_60}>
            Registration No.
          </SecondGreyText>
          <SecondGreyText>-</SecondGreyText>
          <SecondGreyText> {studentDetails?.student?.uniRollNo}</SecondGreyText>
        </SubFLex>
      
      </SubFLex>
    </>
  )
}

export default CurrentlyPursuing
